// The Tavezio mark, small form: below 32px it inverts to a filled disc with the T reversed out
// (DESIGN.md › The Mark). One color per mark — the color the wordmark takes on that ground — never
// Copper. Geometry is the brand-standards kit's: the disc fills the 100-unit box, the T is its path.
export function Mark({ size = 24 }: { size?: number }) {
  return (
    <svg viewBox="0 0 100 100" width={size} height={size} aria-hidden="true">
      <circle cx="50" cy="50" r="50" fill="var(--frost)" />
      <g transform="translate(50,50) scale(0.43810) translate(-175.0,-192.9)">
        <path d="M151.4,245.4v-4.5l6.15-1.5c4.1-.9,6.15-3.4,6.15-7.5v-85.5h-12.75c-3.7,0-6.35.97-7.95,2.92-1.6,1.95-3.3,4.63-5.1,8.03l-5.4,9.5h-1.5l.75-26.45h86.55l.6,26.45h-1.5l-5.4-9.5c-1.7-3.4-3.35-6.08-4.95-8.03-1.6-1.95-4.25-2.92-7.95-2.92h-12.75v85.5c0,4.1,2.05,6.6,6.15,7.5l6.15,1.5v4.5h-47.25Z" fill="var(--spruce)" />
      </g>
    </svg>
  );
}
